//* Libraries imports
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";

interface ErrorMessagesProps {
  messages: string[];
  clearErrors: () => void;
}

export const ErrorMessages: React.FC<ErrorMessagesProps> = ({
  messages,
  clearErrors,
}) => {
  useEffect(() => {
    if (messages.length > 0) {
      const timer = setTimeout(() => {
        clearErrors();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [messages, clearErrors]);

  if (messages.length === 0) return null;

  return (
    <div className="d-flex mb-3 w-100" id="error-message-container">
      <div
        className="alert alert-danger alert-dismissible fade show w-100"
        role="alert"
        id="error-message-alert"
      >
        <Button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={clearErrors}
        />
        {messages.map((message, index) => (
          <p key={index} id={`error-message-${index}`} className="mb-0">
            {message}
          </p>
        ))}
      </div>
    </div>
  );
};
